import { signal } from '@angular/core';

type SidebarState = 'closed' | 'open' | 'closing' | 'opening';

export class FlowpilotSidebarService {
  /** PROPERTIES **/
  /****/
  private _sidebarElement: HTMLElement | null = null;

  /****/
  private readonly state = signal<SidebarState>('closed');

  public init(sidebarElement: HTMLElement) {
    this._sidebarElement = sidebarElement;
  }

  public get stateSignal() {
    return this.state.asReadonly();
  }

  public openSidebar() {
    if (!this._sidebarElement) {
      throw new Error('SidebarService is not initialized.');
    }

    const onEnd = (event: TransitionEvent) => {
      if (event.propertyName !== 'width') return;
      this._sidebarElement!.removeEventListener('transitionend', onEnd);

      this.state.set('open');
    };

    this._sidebarElement.addEventListener('transitionend', onEnd);

    this.state.set('opening');
  }

  public closeSidebar() {
    if (!this._sidebarElement) {
      throw new Error('SidebarService is not initialized.');
    }

    const onEnd = (event: TransitionEvent) => {
      if (event.propertyName !== 'width') return;
      this._sidebarElement!.removeEventListener('transitionend', onEnd);

      this.state.set('closed');
    };

    this._sidebarElement.addEventListener('transitionend', onEnd);

    this.state.set('closing');
  }
}
